function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "m21.0157 18.1202-8.6647 4.8798v-3.8007l5.3986-2.9567 3.266 1.8776zm.5927-.5344v-10.2053l-3.1708 1.822v6.5593zm-18.6827.5344 8.6647 4.8798v-3.8007l-5.3986-2.9567-3.266 1.8776zm-.5927-.5344v-10.2053l3.1707 1.822v6.5593zm.371-10.8656 8.8864-5.0056v3.6748l-5.693 3.1176-.0434.0248zm18.5335 0-8.8865-5.0056v3.6748l5.693 3.1177.0434.0248 3.15-1.8116zm-9.647 11.6146-5.3262-2.9155v-5.7773l5.326 3.062v5.6308zm.7605 0 5.326-2.9155v-5.7773l-5.326 3.062zm-5.726-9.3614 5.3467-2.928 5.3468 2.928-5.3468 3.0744z"
});

var SvgWebpack = function SvgWebpack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWebpack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "webpack.svg";
export { ForwardRef as ReactComponent };